export const LANGUAGES = [
  { code: "en", label: "en", flag: "🇺🇸" },
  { code: "hu", label: "hu", flag: "🇭🇺" },
];
